import { createContext, useContext, useMemo, useState } from 'react';

/**
 * Lets a page tell the shared sticky Header that it opens on a dark "Orchard"
 * hero band, so the header can flip to its light-on-dark treatment and read as
 * part of the band instead of a milk bar floating above it.
 *
 * Only one hero is on screen at a time (one routed page), so a single boolean is
 * enough: OrchardHero sets it true on mount and false on unmount.
 */
const HeroChromeContext = createContext(null);

export function HeroChromeProvider({ children }) {
  const [heroActive, setHeroActive] = useState(false);
  const value = useMemo(() => ({ heroActive, setHeroActive }), [heroActive]);
  return <HeroChromeContext.Provider value={value}>{children}</HeroChromeContext.Provider>;
}

// Safe default so the header still works if it ever renders outside the provider.
export function useHeroChrome() {
  return useContext(HeroChromeContext) ?? { heroActive: false, setHeroActive: () => {} };
}
